import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useModal } from "@ebay/nice-modal-react";

const CreatePeopleButton = ({ onClose }) => {
  const modal = useModal("PeopleDrawer");

  return (
    <>
      <Tooltip title="Create new people">
        <IconButton
          variant="contained"
          size="small"
          onClick={() => modal.show({ formType: "create" })}
        >
          <AddCircleIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default CreatePeopleButton;
